import React, { useEffect, useState } from "react";
import { Page, LoadingMsg } from "components/common";
import { Input, } from "reactstrap";
import { Trans } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { Table } from "reactstrap";
import { ExSpan } from "../../Xero/Settings/TaxReturnsDetail";
import { ZatcaClient } from "services";
import BackButton from "components/refactoring/BackButton";


const s = {
  td: {
    className: "text-left",
  },
  th: {
    className: "text-left",
    style: { fontSize: "1.3em" }
  },
  table: {
    className: "mt-4",
    style: {
      border: '1px solid #ccc',
      borderRadius: '5px',
      margin: '0 auto',
    }
  }
};

export const KeyField = ({ label, value }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    NotificationManager.success(`${label} copied successfully!`);
  };

  return (
    <div className="col-6 my-2">
      <span className="mb-2 text-muted">{label}</span>
      <div className="row">
        <div className="col-10 pr-0">
          <Input readOnly defaultValue={value} />
        </div>
        <div className="col-2 pl-0">
          <i className="far fa-copy border p-2" onClick={handleCopy} style={{ fontSize: "1.05rem", cursor: "pointer", backgroundColor: "#F4F7FE" }} />
        </div>
      </div>
    </div>
  );
};

const getType = (code) => {
  const typeOf = {
    "0100": "B2B",
    "1000": "B2C",
    "1100": "Both"
  };
  return typeOf[code] || code;
};

const linkStyle = {
  color: "#72B566",
  textDecoration: 'none',
  transition: 'color 0.2s ease',
};

const ZatcaDetails = ({ match }) => {
  const { id } = match.params;

  const zatca = ZatcaClient()

  const [dataSDK, setDataSDK] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseSDK = await zatca.get(`sdk/${id}`);
        const dataSDK = responseSDK.data;
        setDataSDK(dataSDK);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Page title="Zatca Details" className="inv-table">
      <BackButton />
      {!dataSDK && <LoadingMsg />}
      {dataSDK &&
        <div>
          <div className="text-center my-3" style={{ fontSize: "1.2em" }}>
            <span>
              <Trans>Your Hesaab Organisation is successfully Integrated with Zatca for E-Invoicing</Trans></span>
            <p><Trans>You can now send your
              <a style={linkStyle}
                onMouseEnter={(e) => e.target.style.color = 'grey'}
                onMouseLeave={(e) => e.target.style.color = linkStyle.color}
                href="/accounts_receivable"
              > Invoices</a> directly to Zatca.
            </Trans>
            </p>
          </div>
          <Table {...s.table}>
            <thead>
              <tr>
                <th {...s.th}><Trans>Organisation Tax Details</Trans></th>
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <ExSpan label="Tax Number" value={dataSDK?.vat} />
                <ExSpan label="Country Code" value={dataSDK?.country_code} />
                <ExSpan label="Business Category" value={dataSDK?.business_category} />
              </tr>
              <tr>
                <ExSpan label="Organization" value={dataSDK?.organization} />
                <ExSpan label="Organization Number" value={dataSDK?.organization_unit} />
                <ExSpan label="Business Type" value={getType(dataSDK?.type_of_business_title)} />
              </tr>
              <tr>
                <ExSpan label="Identification Type" value={dataSDK?.id_type} />
                <ExSpan label="Identification Name" value={dataSDK?.id_name || dataSDK?.id_type} />
                <ExSpan label="Identification Number" value={dataSDK?.id_number} />
              </tr>
              <tr>
                <ExSpan label="City" value={dataSDK?.city} />
                <ExSpan label="Subdiv" value={dataSDK?.city_subdiv} />
                <ExSpan label="Street" value={dataSDK?.street} />
              </tr>
              <tr>
                <ExSpan label="Plot" value={dataSDK?.plot} />
                <ExSpan label="Building Number" value={dataSDK?.building} />
                <ExSpan label="Postal Code" value={dataSDK?.postal} />
              </tr>
            </tbody>
          </Table>
          <div className="container border mt-4">
            <div className="row my-3">
              <KeyField label="CSSID User" value={dataSDK?.basic_csid} />
              <KeyField label="CSSID Key" value={dataSDK?.basic_secret} />
              <KeyField label="PSSID User" value={dataSDK?.production_csid} />
              <KeyField label="PSSID Key" value={dataSDK?.production_secret} />
            </div>
          </div>
        </div>
      }
    </Page>
  );
};

export default ZatcaDetails;
